import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'react-final-form';

import { AppState } from 'services/types';
// Form
import { RenderDropdown } from '../../forms';

// Selectors
import { selectOptions } from './selectors';

interface ConnectedProps {
    options: {
        key: number;
        content: string;
        text: string;
        value: number;
    }[];
}

interface OwnProps {
    label?: string;
    name: string;
    placeholder?: string;
    validate?: any;
    disabled?: boolean;
    nullOnUnmount?: boolean;
    multiple?: boolean;
    excludeApplicatorId?: number;
}

type Props = OwnProps & ConnectedProps;

export class SprayOperatorsDropdownComponent extends React.PureComponent<Props> {
    render(): ReactElement {
        const {
            options,
            label,
            name,
            placeholder,
            validate,
            disabled,
            multiple = false,
            nullOnUnmount = false,
            excludeApplicatorId
        } = this.props;

        let filteredOptions = options;
        if (excludeApplicatorId) {
            filteredOptions = options?.filter(
                (option) => option.value !== excludeApplicatorId
            );
        }

        return (
            <Field
                component={RenderDropdown as any}
                label={label}
                name={name}
                options={filteredOptions}
                placeholder={placeholder}
                validate={validate}
                clearable={!disabled}
                fluid
                search
                selection
                closeOnChange
                disabled={disabled}
                multiple={multiple}
                nullOnUnmount={nullOnUnmount}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: selectOptions
});

export default connect(mapStateToProps)(SprayOperatorsDropdownComponent);
